import { useEffect, useState } from "react";

import { notEmpty } from "shared/lib/utils";

type IframeMessageData = {
  "datawrapper-height"?: Record<string, number>;
  "multimedia-height"?: Record<string, number>;
};

/**
 * Tracks an iframe height from the datawrapper / SCMP multimedia postMessage
 * height events. `messageKey` is the iframe id or src the embed uses as the
 * height message key.
 */
export const useIframeMessageHeight = (messageKey: string, initialHeight: number) => {
  const [height, setHeight] = useState(initialHeight);

  useEffect(() => {
    const handler = (event: MessageEvent<IframeMessageData>) => {
      if (
        !notEmpty(event?.data["datawrapper-height"]) &&
        !notEmpty(event?.data["multimedia-height"])
      )
        return;

      const key = messageKey.replaceAll("datawrapper-chart-", "");
      const messageHeight =
        event?.data?.["datawrapper-height"]?.[key] ?? event?.data?.["multimedia-height"]?.[key];

      if (notEmpty(messageHeight)) {
        setHeight(messageHeight);
        return;
      }
    };

    window.addEventListener("message", handler);
    return () => {
      window.removeEventListener("message", handler);
    };
  }, [messageKey]);

  return height;
};
